/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Location_HintInputs */

const en_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines driving range and teaching facility.`)
};

const es_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campo de práctica y lugar de clases en Des Moines.`)
};

const de_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range und Lehreinrichtung.`)
};

const zh_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得梅因练习场和教学设施。`)
};

const ar_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميدان تدريب وتعليم الغولف في Des Moines.`)
};

const fr_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice de Des Moines et centre d'enseignement.`)
};

const vi_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sân tập và cơ sở giảng dạy tại Des Moines.`)
};

const sw_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range na kituo cha mafunzo ya gofu.`)
};

const th_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามฝึกซ้อมกอล์ฟ Des Moines และสถานที่สอน`)
};

const bs_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježbalište i prostor za poduku u Des Moinesu.`)
};

const ja_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デモイン・ドライビングレンジおよび指導施設。`)
};

const ko_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range 및 교육 시설.`)
};

const pt_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range e centro de ensino de golfe.`)
};

const it_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range e centro di insegnamento del golf.`)
};

const sv_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range och golfundervisning.`)
};

const nl_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines driving range en onderwijsfaciliteit.`)
};

const da_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range og golfundervisning.`)
};

const nb_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range og golfundervisning.`)
};

const fi_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range ja golfopetuskeskus.`)
};

const pl_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range i ośrodek nauki golfa.`)
};

const ru_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range и центр обучения гольфу.`)
};

const tr_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range ve golf eğitim tesisi.`)
};

const hi_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines ड्राइविंग रेंज और शिक्षण सुविधा।`)
};

const id_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range dan fasilitas pelatihan golf.`)
};

const ms_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range dan kemudahan latihan golf.`)
};

const cs_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range a výukové zařízení Des Moines.`)
};

const el_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range και κέντρο εκμάθησης γκολφ.`)
};

const he_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range ומרכז לימוד גולף.`)
};

const af_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range en onderrigfasiliteit.`)
};

const hu_contact_location_hint = /** @type {(inputs: Contact_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range és golfoktató központ.`)
};

/**
* | output |
* | --- |
* | "Des Moines driving range and teaching facility." |
*
* @param {Contact_Location_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_location_hint = /** @type {((inputs?: Contact_Location_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Location_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_location_hint(inputs)
	if (locale === "de") return de_contact_location_hint(inputs)
	if (locale === "zh") return zh_contact_location_hint(inputs)
	if (locale === "ar") return ar_contact_location_hint(inputs)
	if (locale === "fr") return fr_contact_location_hint(inputs)
	if (locale === "vi") return vi_contact_location_hint(inputs)
	if (locale === "sw") return sw_contact_location_hint(inputs)
	if (locale === "th") return th_contact_location_hint(inputs)
	if (locale === "bs") return bs_contact_location_hint(inputs)
	if (locale === "ja") return ja_contact_location_hint(inputs)
	if (locale === "ko") return ko_contact_location_hint(inputs)
	if (locale === "pt") return pt_contact_location_hint(inputs)
	if (locale === "it") return it_contact_location_hint(inputs)
	if (locale === "sv") return sv_contact_location_hint(inputs)
	if (locale === "nl") return nl_contact_location_hint(inputs)
	if (locale === "da") return da_contact_location_hint(inputs)
	if (locale === "nb") return nb_contact_location_hint(inputs)
	if (locale === "fi") return fi_contact_location_hint(inputs)
	if (locale === "pl") return pl_contact_location_hint(inputs)
	if (locale === "ru") return ru_contact_location_hint(inputs)
	if (locale === "tr") return tr_contact_location_hint(inputs)
	if (locale === "hi") return hi_contact_location_hint(inputs)
	if (locale === "id") return id_contact_location_hint(inputs)
	if (locale === "ms") return ms_contact_location_hint(inputs)
	if (locale === "cs") return cs_contact_location_hint(inputs)
	if (locale === "el") return el_contact_location_hint(inputs)
	if (locale === "he") return he_contact_location_hint(inputs)
	if (locale === "af") return af_contact_location_hint(inputs)
	if (locale === "hu") return hu_contact_location_hint(inputs)
	return en_contact_location_hint(inputs)
});